import { createContext } from 'react';

const FormSubmittingContext = createContext(false);

export default FormSubmittingContext;
